// import React from "react";
// import MenuDashboard from "../assets/icons/menu-dashboard.svg?react";
import { routes } from './routes'
import { PermissionSet } from '@/models/permission'
import { useTranslation } from 'react-i18next'

export const LOGIN_PAGE_URL = '/iaas/auth/login'

export type ISideMenu = {
  key?: string | number
  title: string
  msg?: string
  icon?: string
  path?: string
  children?: ISideMenu[]
  type?: 'group'
  hidden?: boolean
  permission?: PermissionSet
  adminOnly?: boolean
  roles?: string[]
}

export function getParentRouterMenu(
  pathname: string,
  config: Record<string, ISideMenu[]>,
): ISideMenu | null {
  const walk = (r: ISideMenu): ISideMenu | null => {
    if (!r.children || r.children.length === 0)
      return r.path === pathname ? r : null

    const exist = r.children.some(item => item.path === pathname)
    if (exist) return r

    return r.children.map(i => walk(i)).reduce((a, b) => a || b, null)
  }

  for (const key in config) {
    const r = Object.values(config[key])
      .map(i => walk(i))
      .reduce((a, b) => a || b, null)
    if (r) return r
  }

  return null
}

export const routerConfig: Record<string, ISideMenu[]> = routes as Record<
  string,
  ISideMenu[]
>

export const getSelectedKeys = (path: string) => {
  const walk = (menus: ISideMenu[]): string[] => {
    for (const menu of menus) {
      if (menu.path === path) {
        return [menu.title]
      }
      if (menu.children) {
        const res = walk(menu.children)
        if (res.length) {
          return [menu.title, ...res]
        }
      }
    }
    return []
  }
  for (const key in routerConfig) {
    const keys = walk(routerConfig[key])
    if (keys.length) {
      return keys
    }
  }
  return []
}

// 国际化版本
export const getSelectedKeysI18n = (path: string, t: (key: string) => string) => {
  const walk = (menus: ISideMenu[]): string[] => {
    for (const menu of menus) {
      if (menu.path === path) {
        return [t(`config:${menu.title}`)]
      }
      if (menu.children) {
        const res = walk(menu.children)
        if (res.length) {
          return [t(`config:${menu.title}`), ...res]
        }
      }
    }
    return []
  }
  for (const key in routerConfig) {
    const keys = walk(routerConfig[key])
    if (keys.length) {
      return keys
    }
  }
  return []
}

export const userInfoApi = '/api/v1/auth/user'
